// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "app." + "82264fb39ac5d6ed726e" + ".js";
};